import React, { useState, useCallback, useEffect } from 'react';
import { roles } from '../../Constants';
import useApi from '../../api/useApi';

function index({ handleClose, showNotification, upDateAvatar, user }) {
  const orgId = JSON.parse(sessionStorage.user).organization.id;

  const formModel = {
    userName: user.userName,
    slug: user.slug,
    email: user.email,
    contact: user.contact,
    avatar: user.avatar,
    role: user.role,
    organizationId: orgId,
  };

  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, updateData] = useApi();

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  useEffect(() => {
    if (!isLoading && !isError && data !== null) {
      showNotification('success', 'User updated successfully');
      handleClose();
    }
    if (isError) {
      showNotification('error', data);
    }
  }, [isLoading, isError, data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    updateData(`/user/${user.userId}`, 'PATCH', formData);
    upDateAvatar();
    // handleClose();
  };

  const getRole = (roleCode) => {
    const x = roles.filter((role) => role.id == roleCode);
    return x[0].value;
  };

  return (
    <div>
      {/* <p className="mt-3 font-bold text-lg text-textBlue1">General Info</p> */}
      <form className="mt-3 flex flex-wrap text-sm" onSubmit={handleSubmit} autoComplete="off">
        <div className="mt-5 w-2/5 relative">
          {/* <label htmlFor="userName" className="block text-parameter w-1/3 text-sm">
              NAME
            </label> */}
          <input
            type="text"
            placeholder="Name"
            value={formData.userName}
            autoComplete="off"
            name="userName"
            className="inputLabelText px-4 py-2 rounded-xl focus:outline-none"
            onChange={handleInputChange}
          />
        </div>

        <div className="mt-5 ml-16 w-2/5 relative">
          {/* <label htmlFor="slug" className="block text-parameter w-1/3 text-sm">
              SHORT NAME
            </label> */}
          <input
            type="text"
            placeholder="Short Name"
            value={formData.slug}
            autoComplete="off"
            name="slug"
            className="inputLabelText px-4 py-2 focus:outline-none"
            onChange={handleInputChange}
          />
        </div>

        <div className="mt-5 w-2/5 relative">
          {/* <label htmlFor="email" className="block text-parameter w-1/3 text-sm">
              EMAIL
            </label> */}
          <input
            type="email"
            placeholder="Email"
            value={formData.email}
            name="email"
            autoComplete="off"
            className="inputLabelText px-4 py-2 focus:outline-none"
            onChange={handleInputChange}
          />
        </div>

        <div className="mt-5 ml-16 w-2/5 relative">
          {/* <label htmlFor="contact" className="block text-parameter w-1/3 text-sm">
              PHONE NUMBER
            </label> */}
          <input
            type="tel"
            placeholder="Phone Number"
            value={formData.contact}
            name="contact"
            autoComplete="off"
            className="inputLabelText px-4 py-2 focus:outline-none"
            onChange={handleInputChange}
          />
        </div>

        <div className="mt-5 w-2/5 relative">
          {/* <label htmlFor="role" className="block text-parameter w-1/3 text-sm">
              ROLE
            </label> */}

          <div className="inputLabelText px-4 py-2 focus:outline-none">
            <select
              name="role"
              value={formData.role}
              className="border-none w-full focus:outline-none text-xs text-parameter border"
              onChange={handleInputChange}
            >
              {roles.map((item) => (
                <option key={item.id} value={item.id} className="fy-4">
                  {item.value}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="mt-5 w-full relative" />
        {/* <div className="w-7/12 mt-5 mb-2" /> */}
        <div className="w-full relative mb-6">
          {/* <label className="block text-parameter w-1/3 text-sm" /> */}
          {isLoading ? (
            <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto" alt="" />
          ) : (
            <div className="flex text-xs absolute right-12">
              <button
                type="submit"
                onClick={() => handleClose()}
                className="rounded-3xl border focus:outline-none w-28 h-9 mr-3 cursor-pointer "
                // style={{ border: '1px solid #16406D' }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="rounded-3xl focus:outline-none w-28 h-9 text-white cursor-pointer"
                style={{ background: '#16406D' }}
              >
                Save
              </button>
            </div>
          )}
        </div>
        {/* <div className="flex w-full items-center justify-end mt-6 relative">
          {isLoading ? (
            <img src="assets/img/loader.svg" className="w-16 mr-6 ml-auto" alt="" />
          ) : (
            <input
              type="submit"
              value="Save Changes"
              className="rounded-lg focus:outline-none w-1/4 mr-8 h-10 text-textBlue1 cursor-pointer "
              style={{ background: '#16406D33', border: '1px solid #16406D' }}
            />
          )}
        </div> */}
      </form>
    </div>
  );
}

export default index;
